import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import AuthContext from "../../context/auth/authContext";
import defaultPhoto from "../../img/defaultUser.jpeg";
import ErrorLogger from "../ErrorLogger";

const Photo = () => {
  const [photo, setPhoto] = useState(null);
  const authContext = useContext(AuthContext);
  const { user } = authContext;

  const getPhoto = async () => {
    const hasPhoto = localStorage.getItem("hasPhoto");

    if (hasPhoto === "false") {
      //console.log("Skipping photo request to avoid 404.");
      setPhoto(null);
      return;
    }
    try {
      // Set withCredentials to false for Graph API call
      axios.defaults.withCredentials = false;

      const photoImage = await axios.get(
        "https://graph.microsoft.com/v1.0/me/photo/$value",
        {
          headers: {
            Authorization: `Bearer ${
              user.accessTokens[user.accessTokens.length - 1]
            }`,
          },
          responseType: "arraybuffer",
        }
      );

      // Reset withCredentials to true after Graph API call
      axios.defaults.withCredentials = true;

      setPhoto(Buffer.from(photoImage.data, "binary").toString("base64"));
    } catch (error) {
      // Reset withCredentials to true in case of error
      axios.defaults.withCredentials = true;
      console.log("Error fetching photo:", error.message);

      // Parse error response if it's in arraybuffer format
      let errorCode = null;
      if (error.response?.data) {
        try {
          const errorText = Buffer.from(error.response.data).toString('utf-8');
          const errorJson = JSON.parse(errorText);
          errorCode = errorJson.error?.code;
        } catch (parseError) {
          // If parsing fails, check status code
          errorCode = error.response?.status === 404 ? "ImageNotFound" : null;
        }
      }

      if (errorCode === "ImageNotFound" || error.response?.status === 404) {
        localStorage.setItem("hasPhoto", "false");
        setPhoto(null);
      } else {
        console.error(error.message);
        ErrorLogger.logError(error, 'AdminPhoto.js');
      }
    }
  };

  useEffect(() => {
    getPhoto();
  }, [user]);

  return (
    <img
      src={photo == null ? defaultPhoto : `data:image/png;base64, ${photo}`}
      className="admin-photo"
      alt=""
    />
  );
};

export default Photo;
